import {
  Box,
  Flex,
  Divider,
  useColorMode,
  useColorModeValue,
  IconButton,
} from "@chakra-ui/react";
import { MoonIcon, SunIcon } from "@chakra-ui/icons";
import React, { useState, useEffect } from "react";
import { getTimeBasedMode } from "../App";
import { NavLink } from "react-router-dom";
import { LogoOriginal as Logo } from "./Logo";
import SocialBar from "./SocialBar";

const FONT = "'Josefin Sans', sans-serif";

export default function NavBar() {
  const [hoveredLink, setHoveredLink] = useState(null);
  const { colorMode, toggleColorMode, setColorMode } = useColorMode();

  useEffect(() => {
    setColorMode(getTimeBasedMode());
  }, [setColorMode]);

  const COLOR_IDLE   = useColorModeValue("#888888", "#777777");
  const COLOR_ACTIVE = useColorModeValue("#333333", "#dddddd");
  const COLOR_HOVER  = useColorModeValue("#555555", "#aaaaaa");
  const DIVIDER      = useColorModeValue("#e4e4e4", "#2D3748");

  const nav_links = [
    { name: "HOME", goto: "/" },
    { name: "BLOG", goto: "posts" },
    { name: "CONTACT", goto: "contact" },
  ];

  return (
    <Box
      as="header"
      w="100%"
      textAlign="center"
      pt={8}
      pb={2}
      position="relative"
    >
      {/* Top rule */}
      <Divider borderColor={DIVIDER} mb={8} />

      {/* Light / dark toggle — top-right corner */}
      <Box position="absolute" top="32px" right="0">
        <IconButton
          aria-label={colorMode === "light" ? "Switch to dark mode" : "Switch to light mode"}
          icon={colorMode === "light" ? <MoonIcon /> : <SunIcon />}
          onClick={toggleColorMode}
          variant="ghost"
          size="sm"
          color={COLOR_IDLE}
          _hover={{ color: COLOR_ACTIVE, bg: "transparent" }}
        />
      </Box>

      {/* Logo */}
      <Box mb={7} userSelect="none">
        <Logo height={34} />
      </Box>

      {/* Navigation links */}
      <Flex
        as="nav"
        justify="center"
        align="center"
        gap={{ base: "16px", md: "32px" }}
        wrap="wrap"
        mb={7}
      >
        {nav_links.map((link) => (
          <NavLink
            key={link.name}
            to={link.goto}
            end={link.goto === "/"}
            style={({ isActive }) => ({
              fontFamily: FONT,
              fontSize: "13px",
              fontWeight: "600",
              letterSpacing: "0.18em",
              textTransform: "uppercase",
              textDecoration: "none",
              color: isActive
                ? COLOR_ACTIVE
                : hoveredLink === link.name
                ? COLOR_HOVER
                : COLOR_IDLE,
              transition: "color 0.25s ease",
            })}
            onMouseEnter={() => setHoveredLink(link.name)}
            onMouseLeave={() => setHoveredLink(null)}
          >
            {link.name}
          </NavLink>
        ))}
      </Flex>

      {/* Bottom rule */}
      <Divider borderColor={DIVIDER} />

      <SocialBar />
    </Box>
  );
}
